import { render, staticRenderFns } from "./CommentTabSelector.vue?vue&type=template&id=2d5e38ce&scoped=true&"
import script from "./CommentTabSelector.vue?vue&type=script&lang=ts&"
export * from "./CommentTabSelector.vue?vue&type=script&lang=ts&"
import style0 from "@/scss/workflow.scss?vue&type=style&index=0&lang=scss&"
import style1 from "./CommentTabSelector.vue?vue&type=style&index=1&id=2d5e38ce&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d5e38ce",
  null
  
)

export default component.exports